// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 3524 ? "app" : chunkId) + "." + {"1867":"8674eac098b2d14240e0","3524":"5c4c216784fc24d4f49c"}[chunkId] + ".css";
};